/**
 * rgb 颜色转换成数组
 * @param str
 * @returns
 */
export function rgb2arr(str) {
    return [parseInt(str.substr(1, 2), 16), parseInt(str.substr(3, 2), 16), parseInt(str.substr(5, 2), 16)];
}
//# sourceMappingURL=rgb2arr.js.map